import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const OrgAPI = {
  getAll: function ({ search, start, end, status, offset, limit }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/super-admin/organizations`,
      params: { search, start, end, status, offset, limit },
      cancelToken: cancelTokenObject[this.getAll.name].requestCancellation().token,
    })
  },
  create: function (data) {
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations`,
      data: data,
    })
  },
  getById: function (org_id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}`,
      cancelToken: cancelTokenObject[this.getById.name].requestCancellation().token,
    })
  },
  update: function ({ org_id, auto_validate, verification, confidence_threshold, info = {} }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/organizations/${org_id}`,
      data: { auto_validate, verification, confidence_threshold, ...info },
    })
  },
  leave: function (org_id) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/organizations/${org_id}/leave`,
    })
  },
  getProfileImage: function (org_id) {
    return axiosInstance
      .request({
        method: 'GET',
        url: `/organizations/${org_id}/profile-img`,
        responseType: 'blob',
      })
      .then(res => {
        if (res.data?.type.indexOf('image') === -1) {
          return null
        }
        return { data: new Blob([res.data], { type: res.data?.type }) }
      })
  },
  uploadProfileImage: function (org_id, file) {
    let formData = new FormData()
    formData.append('file', file)

    axiosInstance.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    return axiosInstance
      .request({
        method: 'PUT',
        url: `/organizations/${org_id}/profile-img/upload`,
        data: formData,
        responseType: 'blob',
      })
      .then(res => {
        return { data: new Blob([res.data]) }
      })
  },
}

const cancelTokenObject = createCancelToken(OrgAPI)
export default OrgAPI
